import React from 'react';

const AWS_EBS = () => {
  return (
    <div>
      <h1>AWS_EBS</h1>
      <p>This is the AWS_EBS component.</p>
    </div>
  );
};

export default AWS_EBS;
